import { Plural } from "@lingui/react/macro";
import React from "react";
import { DescriptionTextColumnIconHighlights } from "@silversea-ssc/ui-components-react";
import { isPresent } from "src/utils/checks";

interface CruiseItineraryPortsSummaryProps {
  ports?: number;
  countries?: number;
  routesCount?: number;
}

const CruiseItineraryPortsSummary: React.FC<
  React.PropsWithChildren<CruiseItineraryPortsSummaryProps>
> = ({ ports = 0, countries = 0, routesCount }) => {
  const items = [
    {
      key: "port",
      icon: "anchor" as const,
      label: <Plural value={ports} one="# Port" other="# Ports" />
    },
    routesCount && routesCount > 0
      ? {
          key: "route",
          icon: "routes" as const,
          label: <Plural value={routesCount} one="# Route" other="# Routes" />
        }
      : undefined,
    {
      key: "countries",
      icon: "flag" as const,
      label: <Plural value={countries} one="# Country" other="# Countries" />
    }
  ].filter(isPresent);

  return <DescriptionTextColumnIconHighlights items={items} />;
};

export default CruiseItineraryPortsSummary;
